import { render } from "./Header.vue?vue&type=template&id=f2cf9b46&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=f2cf9b46&lang=scss&scoped=true"
import "./Header.vue?vue&type=style&index=1&id=f2cf9b46&lang=scss"

import exportComponent from "/Users/chris.bamford/Documents/GitHub/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2cf9b46"]])

export default __exports__